import type { Breadcrumb, LogEntry } from "./types";
import { getConfig } from "./config";

let trail: Breadcrumb[] = [];

function maxSize(): number {
  return getConfig().breadcrumbSize;
}

export function addBreadcrumb(entry: LogEntry): void {
  const max = maxSize();
  if (max <= 0) return;

  const crumb: Breadcrumb = {
    timestamp: entry.timestamp,
    level: entry.level,
    namespace: entry.namespace,
    fileName: entry.fileName,
    message: entry.message,
  };

  trail.push(crumb);

  if (trail.length > max) {
    trail = trail.slice(trail.length - max);
  }
}

export function getBreadcrumbs(): Breadcrumb[] {
  return [...trail];
}

export function clearBreadcrumbs(): void {
  trail = [];
}
